var exports = {
  "X": "ConnectionsTab.module__confirmDescription___cU1UNT",
};

module.exports = exports;
